import { useNavigate } from "react-router-dom";
import CreateToken from "../../js/CreateToken";
import { directCancelServiceAPI } from "../../apis/MemberAPICalls";
import { decrypt } from "../../js/encrypt";
import { useSelector } from "react-redux";

function ConfirmDirectCancelServiceModal({ status, setStatus, purchasedInfo }) {

  const navigate = useNavigate();
  
  const closeModal = () => {
    setStatus(false);
  };

  const directCancelService = async () => {
    const resCode = await directCancelServiceAPI(decrypt(sessionStorage.getItem("mem_seq")), purchasedInfo.seq, CreateToken());

    if(1 === resCode) navigate("/history", {replace: true});
    else return;
  };

  return (
    <>
        <div className={ status ? "modal smallModal active" : "modal smallModal" }>
          <div className="modalNoHeader">
            <div className="modalTxt1">
              STORR의 프리미엄 서비스를<br/>
              바로 해지 하시겠습니까?
            </div>
          </div>

          <div className="modalButtons">
            <div className="inside">
              <button tabIndex={0} className="buttonCancel button1in2" title="" onClick={closeModal}>결제 유지하기</button>
              <button tabIndex={0} className="buttonDone button1in2" title="" onClick={directCancelService}>결제 해지하기</button>
            </div>
          </div>
        </div>
      
      <button tabIndex={0} className={ status ? "dimm active" : "dimm" } title="닫기" onClick={closeModal}></button>
    </>
  );
}

export default ConfirmDirectCancelServiceModal;